// @flow

const TABS_DMS_SELECTOR = 'tabs-dms-panel';
const TAB_VIEW_CONTENT = 'tab-dms-view-content';

const PAGE_VIEW_SELECTOR = 'page-my-dms-insurance-view';

const MEDICAL_OFFICES_MAP_ELEMENT_ID = 'app-my-dms-insurance-offices-map';

export const SELECTORS = {
	TABS_DMS_SELECTOR,
	TAB_VIEW_CONTENT,

	PAGE_VIEW_SELECTOR,

	MEDICAL_OFFICES_MAP_ELEMENT_ID,
};
